import { render, staticRenderFns } from "./appointmentComm.vue?vue&type=template&id=484d9d70&"
import script from "./appointmentComm.vue?vue&type=script&lang=js&"
export * from "./appointmentComm.vue?vue&type=script&lang=js&"
import style0 from "./appointmentComm.vue?vue&type=style&index=0&id=484d9d70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports